import { useT } from '@/shared/i18n/useT';

/** Suspense fallback for lazy module chunks. Never a blank screen. */
export function RouteFallback() {
  const t = useT();
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-48 items-center justify-center gap-3 text-sm text-muted"
    >
      <span className="h-4 w-4 animate-spin rounded-full border-2 border-border border-t-accent" />
      <span>{t('common.loading')}</span>
    </div>
  );
}
